import { Box, Text, Touchable } from '@factorialco/deprecated-design-system'

import RadioInput from 'modules/core/components/Inputs/FilterSelect/SelectOption/RadioInput'
import i18n from 'modules/core/lib/i18n'

export type RecurrentType = 'custom' | 'all'

interface RecurrentTypeSelectorProps {
  recurrentType: RecurrentType
  onSelectRecurrentType: (value: RecurrentType) => void
}

const RecurrentTypeSelector = ({
  onSelectRecurrentType,
  recurrentType,
}: RecurrentTypeSelectorProps) => {
  const isAllSelected = recurrentType === 'all'

  return (
    <Box gap="s16">
      <Box
        gap="s16"
        border={{
          all: {
            width: 's2',
            style: 'solid',
            color: isAllSelected ? 'viridian1000' : 'grey400',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
        padding="s16"
      >
        <Box flexDirection="row" justifyContent="spaceBetween">
          <Text.Normal weight="semibold">
            {i18n.t('project_management.schedule.recurrent_type_modal.options.all.title')}
          </Text.Normal>
          <Touchable onClick={() => onSelectRecurrentType('all')} autofocus={isAllSelected}>
            <RadioInput selected={isAllSelected} />
          </Touchable>
        </Box>
        <Text.Normal>
          {i18n.t('project_management.schedule.recurrent_type_modal.options.all.description')}
        </Text.Normal>
      </Box>
      <Box
        gap="s16"
        border={{
          all: {
            width: 's2',
            style: 'solid',
            color: !isAllSelected ? 'viridian1000' : 'grey400',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
        padding="s16"
      >
        <Box flexDirection="row" justifyContent="spaceBetween">
          <Text.Normal weight="semibold">
            {i18n.t('project_management.schedule.recurrent_type_modal.options.custom.title')}
          </Text.Normal>
          <Touchable onClick={() => onSelectRecurrentType('custom')} autofocus={!isAllSelected}>
            <RadioInput selected={!isAllSelected} />
          </Touchable>
        </Box>
        <Text.Normal>
          {i18n.t('project_management.schedule.recurrent_type_modal.options.custom.description')}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default RecurrentTypeSelector
